import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../auth/useAuth';
import { makeApi } from '../api/client';
import { WarehouseFormDialog } from '../components/WarehouseFormDialog';
import type { WarehouseInput } from './warehouses.schema';

export default function WarehousesRoute() {
  const { getAccessToken } = useAuth();
  const api = makeApi(getAccessToken);
  const qc = useQueryClient();
  const [createOpen, setCreateOpen] = useState(false);
  const q = useQuery({
    queryKey: ['warehouses'],
    queryFn: async () => (await api.org.listWarehouses()).data,
  });
  const create = useMutation({
    mutationFn: (d: WarehouseInput) => api.org.createWarehouse({ body: { name: d.name, address: d.address, gstin: d.gstin } }),
    onMutate: async (d) => {
      await qc.cancelQueries({ queryKey: ['warehouses'] });
      const prev = qc.getQueryData<any>(['warehouses']);
      qc.setQueryData(['warehouses'], (o: any) => ({ items: [...(o?.items ?? []), { id: 'tmp', ...d }], next_cursor: null }));
      return { prev };
    },
    onError: (_e, _v, ctx) => qc.setQueryData(['warehouses'], (ctx as any)?.prev),
    onSettled: () => qc.invalidateQueries({ queryKey: ['warehouses'] }),
    onSuccess: () => setCreateOpen(false),
  });
  return (
    <section>
      <header className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold text-primary">Warehouses</h1>
        <button onClick={() => setCreateOpen(true)} className="rounded bg-primary px-4 py-2 text-white">Create warehouse</button>
      </header>
      {q.data?.items?.length === 0 && <p className="text-ink/60">No warehouses yet. Create your first warehouse to track stock locations.</p>}
      <ul>{q.data?.items?.map((w) => <li key={w.id} className="border-b py-2">{w.name} — <span className="text-ink/60">{w.address}</span></li>)}</ul>
      <WarehouseFormDialog open={createOpen} onClose={() => setCreateOpen(false)} onSubmit={(d) => create.mutate(d)} mode="create" />
    </section>
  );
}
